//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import chunk from "lodash.chunk"

export default {

    name: 'ProfileServices',

    mixins: [ProfileData],

    props: {
        company: {
        },
        destination: {
        },
    },

    methods: {

      serviceLists(row) {
        return chunk(row, 3)
      },

    },

    computed: {

        serviceRows() {
          return chunk(this.destination.servicesDisplayArr, 9)
        },

    }

}

